import router from "@/router";
import Vue from 'vue';
import store from "@/vuex/store";

var isAlert = false

export const setInterceptors = (axiosInstance) => {
    axiosInstance.interceptors.request.use(
        config => {
            store.dispatch('setGlobalLoading', true)
            config.baseURL = ['/static','/file'].some(it=> config.url.includes(it)) ? "" : '/api'
            return config;
        },
        err => {
            return Promise.reject(err);
        }
    );
    axiosInstance.interceptors.response.use(
        response => {
            
            store.dispatch('setGlobalLoading', false)
            if ((response.data.status === '0' || response.data.status === '6') && (router.currentRoute.path !== '/login')) {
                // if (!isAlert) {
                //     isAlert = true;
                //     Vue.prototype.$alert(response.data.msg || '请登录！', '提示', {
                //         confirmButtonText: '确定',
                //         callback: action => {
                //             router.push({
                //                 path: '/login'
                //             })
                //         }
                //     })
                // }
                return response;
            }
            
            if(response.config.url.startsWith('/api/openm')&&response.data.code===10000){
                return response.data
            }
            if(response.data.code === 50000){
                Vue.prototype.$notify.error({
                    title: 'Error',
                    message: `${response.config.url}-${response.data.msg}`,
                    position: 'bottom-right'
                });
                return Promise.reject('error')
            }
            isAlert = false;
            if (response.data.status === '1' || response.data.status === '4') {//无权限
                Vue.prototype.$alert(response.data.msg, '提示', {
                    confirmButtonText: '确定',
                    callback: action => { }
                })
            }
            return response;
        },
        error => {
            store.dispatch('setGlobalLoading', false)
            Vue.prototype.$notify.error({
                title: 'Error',
                message: error.message || 'Network Error',
                position: 'bottom-right'
            });
            return Promise.reject(error)
        }
    );
}


// WEBPACK FOOTER //
// ./src/http/interceptors.js